import { IDefaultPopupCustomStyles } from '@r1-frontend/ui-react/components/popups/defaultPopup';

export const PopupCustomStyles: IDefaultPopupCustomStyles = {
    popup: {
        default: {
            margin: '32px',
            maxHeight: 'calc(100% - 64px)',
        },
        mobile: {
            margin: '16px',
            maxHeight: 'calc(100% - 32px)',
        },
    },
};
